import AttachmentResource from '@/api/resources/attachment/attachmentResource'

class LaboratoryAttachmentService extends AttachmentResource {
    async getFile(laboratoryId) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/logo`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }).then(response => response.data)
    }
}

export default new LaboratoryAttachmentService()
